/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ApprovePunchRequestRequestV2 } from '../api-models';
// @ts-ignore
import { ProblemDetails } from '../api-models';
// @ts-ignore
import { PunchRequestDecisionResponse } from '../api-models';
/**
 * PunchRequestsV2Api - axios parameter creator
 * @export
 */
export const PunchRequestsV2ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Writes the punch the employee asked for (added for a missing punch, changed for a time  change) with the date and time the manager chose and, for a missing punch, the punch type  they chose (a time change keeps the punch\'s type unless one is sent), and marks the request  Accepted, together with the same request sent again (same kind and time); a request for  another time stays open. Only this request is pushed. A missing punch already on the time  card is not added again, nor a punch already holding the approved time (and type, when one  was sent) edited again: the request is only marked Accepted and `punchWritten` is  false. Needs the  punch add or edit permission for the employee, and, when a punch is written, an editable pay  period, like a manual add or edit; and a missing punch the calc files under its shift\'s pay  date (a night shift\'s Out, a lunch return after midnight) is refused when the recalculation  after the add does not reach that date (the shift\'s period closed or approved, or no pay  period set up for today); the message names the date.
         * @param {number} punchNotificationId 
         * @param {ApprovePunchRequestRequestV2} [approvePunchRequestRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PunchRequestsPunchNotificationIdApprovePost: async (punchNotificationId: number, approvePunchRequestRequestV2?: ApprovePunchRequestRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'punchNotificationId' is not null or undefined
            assertParamExists('apiV2PunchRequestsPunchNotificationIdApprovePost', 'punchNotificationId', punchNotificationId)
            const localVarPath = `/api/v2/punch-requests/{punchNotificationId}/approve`
                .replace(`{${"punchNotificationId"}}`, encodeURIComponent(String(punchNotificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(approvePunchRequestRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Marks the request Rejected. The time card is not touched, so a closed pay period does not  stop it, but it needs the same punch permission approving it would. Not a session ender:  it writes only the request row, which undo never captures, so the manager\'s earlier  undoable edits stay undoable.
         * @param {number} punchNotificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PunchRequestsPunchNotificationIdRejectPost: async (punchNotificationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'punchNotificationId' is not null or undefined
            assertParamExists('apiV2PunchRequestsPunchNotificationIdRejectPost', 'punchNotificationId', punchNotificationId)
            const localVarPath = `/api/v2/punch-requests/{punchNotificationId}/reject`
                .replace(`{${"punchNotificationId"}}`, encodeURIComponent(String(punchNotificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PunchRequestsV2Api - functional programming interface
 * @export
 */
export const PunchRequestsV2ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PunchRequestsV2ApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Writes the punch the employee asked for (added for a missing punch, changed for a time  change) with the date and time the manager chose and, for a missing punch, the punch type  they chose (a time change keeps the punch\'s type unless one is sent), and marks the request  Accepted, together with the same request sent again (same kind and time); a request for  another time stays open. Only this request is pushed. A missing punch already on the time  card is not added again, nor a punch already holding the approved time (and type, when one  was sent) edited again: the request is only marked Accepted and `punchWritten` is  false. Needs the  punch add or edit permission for the employee, and, when a punch is written, an editable pay  period, like a manual add or edit; and a missing punch the calc files under its shift\'s pay  date (a night shift\'s Out, a lunch return after midnight) is refused when the recalculation  after the add does not reach that date (the shift\'s period closed or approved, or no pay  period set up for today); the message names the date.
         * @param {number} punchNotificationId 
         * @param {ApprovePunchRequestRequestV2} [approvePunchRequestRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PunchRequestsPunchNotificationIdApprovePost(punchNotificationId: number, approvePunchRequestRequestV2?: ApprovePunchRequestRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PunchRequestDecisionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2PunchRequestsPunchNotificationIdApprovePost(punchNotificationId, approvePunchRequestRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Marks the request Rejected. The time card is not touched, so a closed pay period does not  stop it, but it needs the same punch permission approving it would. Not a session ender:  it writes only the request row, which undo never captures, so the manager\'s earlier  undoable edits stay undoable.
         * @param {number} punchNotificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PunchRequestsPunchNotificationIdRejectPost(punchNotificationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PunchRequestDecisionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2PunchRequestsPunchNotificationIdRejectPost(punchNotificationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PunchRequestsV2Api - factory interface
 * @export
 */
export const PunchRequestsV2ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PunchRequestsV2ApiFp(configuration)
    return {
        /**
         * 
         * @summary Writes the punch the employee asked for (added for a missing punch, changed for a time  change) with the date and time the manager chose and, for a missing punch, the punch type  they chose (a time change keeps the punch\'s type unless one is sent), and marks the request  Accepted, together with the same request sent again (same kind and time); a request for  another time stays open. Only this request is pushed. A missing punch already on the time  card is not added again, nor a punch already holding the approved time (and type, when one  was sent) edited again: the request is only marked Accepted and `punchWritten` is  false. Needs the  punch add or edit permission for the employee, and, when a punch is written, an editable pay  period, like a manual add or edit; and a missing punch the calc files under its shift\'s pay  date (a night shift\'s Out, a lunch return after midnight) is refused when the recalculation  after the add does not reach that date (the shift\'s period closed or approved, or no pay  period set up for today); the message names the date.
         * @param {PunchRequestsV2ApiApiV2PunchRequestsPunchNotificationIdApprovePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PunchRequestsPunchNotificationIdApprovePost(requestParameters: PunchRequestsV2ApiApiV2PunchRequestsPunchNotificationIdApprovePostRequest, options?: AxiosRequestConfig): AxiosPromise<PunchRequestDecisionResponse> {
            return localVarFp.apiV2PunchRequestsPunchNotificationIdApprovePost(requestParameters.punchNotificationId, requestParameters.approvePunchRequestRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Marks the request Rejected. The time card is not touched, so a closed pay period does not  stop it, but it needs the same punch permission approving it would. Not a session ender:  it writes only the request row, which undo never captures, so the manager\'s earlier  undoable edits stay undoable.
         * @param {PunchRequestsV2ApiApiV2PunchRequestsPunchNotificationIdRejectPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PunchRequestsPunchNotificationIdRejectPost(requestParameters: PunchRequestsV2ApiApiV2PunchRequestsPunchNotificationIdRejectPostRequest, options?: AxiosRequestConfig): AxiosPromise<PunchRequestDecisionResponse> {
            return localVarFp.apiV2PunchRequestsPunchNotificationIdRejectPost(requestParameters.punchNotificationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV2PunchRequestsPunchNotificationIdApprovePost operation in PunchRequestsV2Api.
 * @export
 * @interface PunchRequestsV2ApiApiV2PunchRequestsPunchNotificationIdApprovePostRequest
 */
export interface PunchRequestsV2ApiApiV2PunchRequestsPunchNotificationIdApprovePostRequest {
    /**
     * 
     * @type {number}
     * @memberof PunchRequestsV2ApiApiV2PunchRequestsPunchNotificationIdApprovePost
     */
    readonly punchNotificationId: number

    /**
     * 
     * @type {ApprovePunchRequestRequestV2}
     * @memberof PunchRequestsV2ApiApiV2PunchRequestsPunchNotificationIdApprovePost
     */
    readonly approvePunchRequestRequestV2?: ApprovePunchRequestRequestV2
}

/**
 * Request parameters for apiV2PunchRequestsPunchNotificationIdRejectPost operation in PunchRequestsV2Api.
 * @export
 * @interface PunchRequestsV2ApiApiV2PunchRequestsPunchNotificationIdRejectPostRequest
 */
export interface PunchRequestsV2ApiApiV2PunchRequestsPunchNotificationIdRejectPostRequest {
    /**
     * 
     * @type {number}
     * @memberof PunchRequestsV2ApiApiV2PunchRequestsPunchNotificationIdRejectPost
     */
    readonly punchNotificationId: number
}

/**
 * PunchRequestsV2Api - object-oriented interface
 * @export
 * @class PunchRequestsV2Api
 * @extends {BaseAPI}
 */
export class PunchRequestsV2Api extends BaseAPI {
    /**
     * 
     * @summary Writes the punch the employee asked for (added for a missing punch, changed for a time  change) with the date and time the manager chose and, for a missing punch, the punch type  they chose (a time change keeps the punch\'s type unless one is sent), and marks the request  Accepted, together with the same request sent again (same kind and time); a request for  another time stays open. Only this request is pushed. A missing punch already on the time  card is not added again, nor a punch already holding the approved time (and type, when one  was sent) edited again: the request is only marked Accepted and `punchWritten` is  false. Needs the  punch add or edit permission for the employee, and, when a punch is written, an editable pay  period, like a manual add or edit; and a missing punch the calc files under its shift\'s pay  date (a night shift\'s Out, a lunch return after midnight) is refused when the recalculation  after the add does not reach that date (the shift\'s period closed or approved, or no pay  period set up for today); the message names the date.
     * @param {PunchRequestsV2ApiApiV2PunchRequestsPunchNotificationIdApprovePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PunchRequestsV2Api
     */
    public apiV2PunchRequestsPunchNotificationIdApprovePost(requestParameters: PunchRequestsV2ApiApiV2PunchRequestsPunchNotificationIdApprovePostRequest, options?: AxiosRequestConfig) {
        return PunchRequestsV2ApiFp(this.configuration).apiV2PunchRequestsPunchNotificationIdApprovePost(requestParameters.punchNotificationId, requestParameters.approvePunchRequestRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Marks the request Rejected. The time card is not touched, so a closed pay period does not  stop it, but it needs the same punch permission approving it would. Not a session ender:  it writes only the request row, which undo never captures, so the manager\'s earlier  undoable edits stay undoable.
     * @param {PunchRequestsV2ApiApiV2PunchRequestsPunchNotificationIdRejectPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PunchRequestsV2Api
     */
    public apiV2PunchRequestsPunchNotificationIdRejectPost(requestParameters: PunchRequestsV2ApiApiV2PunchRequestsPunchNotificationIdRejectPostRequest, options?: AxiosRequestConfig) {
        return PunchRequestsV2ApiFp(this.configuration).apiV2PunchRequestsPunchNotificationIdRejectPost(requestParameters.punchNotificationId, options).then((request) => request(this.axios, this.basePath));
    }
}
